import { SxProps, Theme } from '@mui/system';

const styles = {

  infoContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  label: {
    fontSize: 12,
    fontWeight: 500,
    color: 'grey.800',
    mr: 1,
  },

  percentage: {
    fontSize: 12,
    fontWeight: 400,
    color: 'grey.500',
  },

  iconRating: {
    color: 'primary.main',
    marginRight: '8px',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
  },

  emptyIcon: {
    color: 'primary.main',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
